<template>
  <div class="profil-list">

    <v-container grid-list-xl fluid >
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-account</v-icon>{{$t('administration.user.users')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
            <v-btn
              class="ml-2"
              v-if="userHasAccess('user_edit')"
              color="primary"
              :to="{ name: 'UserCreate' }"
            >
              {{ $t('global.add')}}
            </v-btn>
          </div>
        </v-toolbar>
        <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
          <UserFilterForm
            ref="filterForm"
            :values="filters"
            slot="filter"
          />
        </DataFilter>

        <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.enabled" slot-scope="{ item }">
                  <strong v-if="item.enabled" >
                    <v-icon color="green">mdi-check-circle</v-icon>
                  </strong>
                  <span v-else>
                    <v-icon color="red">mdi-close-circle</v-icon>
                  </span>
                </template>

          </v-data-table>

      </v-sheet>
    </v-container>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import UserFilterForm from '../../components/user/Filter';
import DataFilter from '../../components/DataFilter';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'UserList',
  servicePrefix: 'User',
  mixins: [ListMixin,AccessMixin],
  components: {
    UserFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('administration.user.login'), value: 'login' },
        { text: this.$t('administration.user.firstname'), value: 'firstname' },
        { text: this.$t('administration.user.lastname'), value: 'lastname' },
        { text: this.$t('administration.profil.profil'), value: 'profil.name' },
        { text: this.$t('administration.user.enabled'), value: 'enabled' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('user', {
      items: 'list'
    }),
    ...mapFields('user', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('user', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
